<template>
	<div>
		<div class="container-fluid wrapper-footer-small">
			<div class="row justify-content-center">
				<div class="col text-center">
					<p>{{ $t('Download the C-Share app from your App Store') }}</p>
				</div>
			</div>
			<div class="row justify-content-center">
				<a href="https://apps.apple.com/de/app/c-share/id1423513572" target="_blank"><img src="/static/img/logo-appstore.png"></a>
				<a href="https://apps.apple.com/de/app/c-share/id1423513572" target="_blank"><img src="/static/img/logo-googleplay.png"></a>
			</div>
			<div class="row justify-content-center"  v-if="!footerLinks">
				<ul class="nav justify-content-center">
				  <li class="nav-item">
				  	<router-link :to="{name: 'PageHome'}"  class="nav-link">
				    	{{ $t('Home') }}
				    </router-link>
				  </li>
				  <li class="nav-item">
				  	<router-link :to="{name: 'PageRegister'}"  class="nav-link">
				    	{{ $t('Register') }}
				    </router-link>
				  </li>
				  <li class="nav-item">
				  	<router-link :to="{name: 'PageContact'}"  class="nav-link">
				    	{{ $t('Contact') }}
				    </router-link>
				  </li>
				  <li class="nav-item">
				  	<router-link :to="{name: 'PageFaq'}"  class="nav-link">
				    	{{ $t('Instructions & FAQ') }}
				    </router-link>
				  </li>

					<li class="nav-item" v-for="item in apiLinks">
						<a :href="item.link" class="nav-link">{{ item.label }}</a>
					</li>
				</ul>
			</div>
			<div class="row justify-content-center"  v-if="footerLinks">
				<ul class="nav justify-content-center">
					<li v-for="(item, index) in footerLinks" class="nav-item" :key="item.path">

						<router-link :to="{name: item.path}"  class="nav-link" v-if="item.type == 'modular/internal'">
				    		{{ $t(item.name) }}
				    	</router-link>

				    	<router-link :to="{ name: 'Page', params: {id: item.path, type: 'footer' } }"  class="nav-link" v-if="item.type == 'modular/page'">
				    		{{ $t(item.name) }}
				    	</router-link>	

				    	<span v-if="item.type === 'modular/external'">
				    		
				    		<a :href="getApiLink(item.path)" class="nav-link" v-if="item.type === 'modular/external'">{{ $t(item.name) }}</a>
				    	</span>

					</li>
				</ul>
			</div>
		</div>
	</div>
</template>


<script>
/**
 * @todo  hier ist defintiv das ganze falsch, eig dürften wir get_params nicht mal öffentlich afurufen (weil wir den authcode von da bekommen und der ja "eig" privat ist)
 */


export default {
	name: "Footer",
	data() {
		return{
			apiLinks: [],
			footerLinks: this.$store.getters['orm/footernavigationAll'],
		};
	},
	computed: {
	    

	},
	methods: {
		getApiLink: function(param){
			if (param.search("http") !== "-1") {
				return param
			}
			if(this.$store.getters['orm/param'](param) !== undefined){

				return this.$store.getters['orm/param'](param).value;
			}
			
		}
	},
	created() {
		var self = this;
		this.$store.dispatch('orm/GET_PARAMS')
		.then(params => {
			let tmplink;
			if(tmplink = this.$store.getters['orm/param']('SAPP_PRIVACY_URL')) {
				this.apiLinks.push({ tmplink });
			}
			if(tmplink = this.$store.getters['orm/param']('SAPP_IMPRINT_URL')) {
				this.apiLinks.push();
			}
		});
	}
	
}
</script>



// WEBPACK FOOTER //
// src/components/Generals/Footer.vue